import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-extension",
  templateUrl: "./med-icon-extension.component.html",
})
export class MedIconExtensionComponent extends SvgMixinComponent {}
